import { SkinnyNode } from '../flowState';
import { isFilter } from 'app/service/utils';
import { isPathNode } from 'app/beta-editor/utils/PathUtils';

const isFilterNode = (node: SkinnyNode) =>
  !isPathNode(node) && isFilter(node.type_of);

export default isFilterNode;
